import React, { useEffect, useState } from "react";
import {
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row
} from "reactstrap";
import Select from "react-select";
import RolesService from "services/Admin/RolesService"

const FilterForm = ({ showFilters, roleId, setRolId, toggle }) => {
    const rolesService = new RolesService()
    const [role, setRole] = useState(null)
    const [options, setOptions] = useState([])

    useEffect(() => {
        if (roleId ?.length) {
            setRole([...roleId])
        } else {
            setRole(null)
        }
    }, [])

    useEffect(() => {
        rolesService.getDropDown().then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: item.name.en,
                    value: item.id
                }
            })
            setOptions(newOptions)
        })
    }, [])

    return (
        <Modal isOpen={showFilters} toggle={toggle}
            className="rightModalSide scrollbar-container mt-0">
            <ModalHeader toggle={toggle}>
                Admins Filters
            </ModalHeader>
            <ModalBody>
                <Row className="d-flex justify-content-between">
                    <Col md={12}>
                        <label>Role</label>
                        <Select
                            placeholder={"Select"}
                            options={options}
                            onChange={(data) => {
                                setRole(data)
                            }}
                            value={role}
                            isMulti={true}

                        />
                    </Col>

                </Row>
            </ModalBody>
            <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                <button type='button' className='btn btn-light w-120' onClick={() => {
                    setRolId(null)
                    setRole(null)
                }}>
                    Reset Filter
                           </button>
                <button type='button' onClick={() => {
                    if (role ?.length) {
                        setRolId([...role])
                    } else {
                        setRolId(null)
                    }
                    toggle()
                }} className='btn btn-success  w-120'>
                    Apply Filter
                            </button>
            </ModalFooter>
        </Modal>
    )
}

export default FilterForm